const acceptCookies = document.querySelector('.js-accept-cookies');
const acceptCookiesBtn = document.querySelector('.js-accept-cookies__btn');

if (acceptCookies && acceptCookiesBtn) {
	const key = 'accept-cookies';
	const data = localStorage.getItem(key);
	const today = new Date();
	const todayTimestamp = today.getTime();
	const expiryDateTimestamp = new Date(new Date().setDate(today.getDate() + 30)).getTime();

	const saveToLocalStorage = () => {
		const object = { expiry: expiryDateTimestamp };
		localStorage.setItem(key, JSON.stringify(object));
	};

	if (data) {
		const parsedData = JSON.parse(data);

		if (todayTimestamp > parsedData.expiry) {
			acceptCookies.classList.add('show');
		}
	} else {
		acceptCookies.classList.add('show');
	}

	acceptCookiesBtn.addEventListener('click', () => {
		acceptCookies.classList.remove('show');
		saveToLocalStorage();
	});
}
